import { KeyValueGambit } from 'flarum/common/query/IGambit';
export default class LabelGambit extends KeyValueGambit {
  key() {
    return '#';
  }
  hint() {
    return 'label';
  }
  filterKey() {
    return 'labels';
  }
  // Parsing and autocomplete use the quote-aware label parser instead.
  enabled() {
    return false;
  }
  fromFilter(value) {
    return (Array.isArray(value) ? value : String(value).split(',')).map(slug => '#' + slug).join(' ');
  }
}
flarum.reg.add('nightash-labels', 'common/query/discussions/LabelGambit', LabelGambit);